import { render, staticRenderFns } from "./ChannelOptions.vue?vue&type=template&id=60993023&scoped=true"
import script from "./ChannelOptions.vue?vue&type=script&lang=js"
export * from "./ChannelOptions.vue?vue&type=script&lang=js"
import style0 from "./ChannelOptions.vue?vue&type=style&index=0&id=60993023&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60993023",
  null
  
)

export default component.exports